// extracted by mini-css-extract-plugin
export default {"container":"Pagination_container__97Os7","item":"Pagination_item__RKhX1","selected":"Pagination_selected__AvkpB","disabled":"Pagination_disabled__7MjsG"};